// extracted by mini-css-extract-plugin
export default {"team-member":"Team_team-member__zAtxS","member-name":"Team_member-name__NRFQ3","member-role":"Team_member-role__F5uLS"};